import React from "react";
import img1 from "../../Assets/homeimgs/Authorisation1.png";
import img2 from "../../Assets/homeimgs/Authorisation2.png";
import img3 from "../../Assets/homeimgs/Authorisation3.png";
import img4 from "../../Assets/homeimgs/img1.jpg";
import img5 from "../../Assets/homeimgs/img2.jpg";
const EmpanelmentsAuthorisation = () => {
  return (
    <React.Fragment>
      <div className="w-full px-4 md:max-w-[70%] mx-auto md:mt-14 mt-8 text-center">
        <h1 className="text-2xl sm:text-3xl lg:text-5xl font-semibold text-center mb-4">
          Empanelments & Authorisation
        </h1>
        <p className="text-gray-600 text-sm sm:text-base md:text-lg lg:text-xl mb-8 lg:mb-12">
          Our empanelments and authorizations reinforce our credibility,
          ensuring compliance with industry standards and offering clients
          trusted, specialized, and regulatory-aligned solutions.
        </p>
      </div>

      <div className="mt-8 px-8 lg:space-x-10  md:px-16 flex flex-col lg:flex-row space-y-6 lg:space-y-0 ">
        <div
          className="w-full  lg:w-[50%] flex items-center justify-center"
          data-aos="fade-down-left "
        >
          <ul className="list-disc list-inside flex flex-col gap-8   text-[#1A1A1A] text-base md:text-md lg:text-md 2xl:text-xl">
            <li>
              Regd. Under Office of the Engineer-in-Chief (Civil), Odisha,
              Nirman Soudha, Bhubaneswar for{" "}
              <span className="text-[#0218DC]">Testing Laboratory</span> vide
              no. 82 of 2018-19 &{" "}
              <span className="text-[#0218DC]">Sub-Soil Explorator</span> vide
              no. 92 of 2019-20.
            </li>
            <li>
              Regd. Under National Accreditation Board for Testing & Calibration
              Laboratories <span className="text-[#0218DC]">(NABL)</span> vide
              no <span className="text-[#0218DC]">TC-15304</span> for Laboratory
              testing in Mechanical & Non-Destructive discipline.
            </li>
            <li>
              Regd. Under{" "}
              <span className="text-[#0218DC]">
                Odisha Bridge & Construction Corporation Limited (obcc)
              </span>{" "}
              vide no 4264 of Dt-17/05/2023 for Survey Investigation & Sub-Soil
              Exploration.
            </li>
            <li>
              Regd. Under{" "}
              <span className="text-[#0218DC]">
                Odisha Construction Corporation Limited (OCC)
              </span>{" "}
              vide no 8894 of Dt-12/07/2023 as Associated Consultant for
              Material Testing, Survey Investigation, DPR Preparation &
              Estimation.
            </li>
          </ul>
        </div>
        <div className="w-full lg:w-[50%]" data-aos="fade-up-right">
          <div className="flex flex-col md:flex-row justify-center gap-3">
            {/* <div className="w-full md:w-[50%] space-y-3">
              <img className="w-full" src={img1} alt="Trophy" />
              <img className="w-full" src={img2} alt="Trophy" />
            </div> */}
            <div className="w-full md:w-[50%] space-y-3">
              <img
                className="w-full h-48 object-fill"
                src={img3}
                alt="Trophy"
              />
              <img className="w-full" src={img4} alt="Trophy" />
            </div>
            <div className="w-full md:w-[50%] space-y-3">
              <img className="w-full" src={img5} alt="Trophy" />
              <img
                className="w-full h-48 object-fill"
                src={img2}
                alt="Trophy"
              />
            </div>
            {/* <div className="w-full md:w-[50%]">
              <img className="w-full h-full" src={img3} alt="Trophy" />
            </div> */}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default EmpanelmentsAuthorisation;
